import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const StripeExternalAccountFormPage = () => import('@modules/stripe/stripe-external-account/components/stripe-external-account-form-page.vue');

export default [{
  name: '',
  path: '',
  component: Layout,
  meta: {
    auth: true
  },
  children: [
    {
      name: 'stripeExternalAccountCreate',
      path: '/subproperty/settings/finantial/account/:connectedAccountId/externalAccount/new',
      component: StripeExternalAccountFormPage,
      props: true,
      meta: {
        auth: true,
        permission: Permissions.values.subpropertyRead,
      },
    },
  ],
}];
